module.exports = __webpack_public_path__ + "img/mortgages.c0b0581.webp";